import type { IReferentialUrlOptions } from '@/core/domain/referential/IReferentialUrlOptions.ts'

export class ReferentialUrlOptions implements IReferentialUrlOptions {
  withDomains?: boolean
  withTasks?: boolean
  withQuizzes?: boolean

  constructor(referentialUrlOptions: IReferentialUrlOptions) {
    this.withDomains = referentialUrlOptions.withDomains
    this.withTasks = referentialUrlOptions.withTasks
    this.withQuizzes = referentialUrlOptions.withQuizzes
  }

  getUrlOptions(): string {
    const params = new URLSearchParams()

    // withDomains is always added because it's independent
    params.append('withDomains', String(this.withDomains))

    // Other parameters are added according to dependency rules
    if (this.withTasks) {
      params.append('withTasks', String(this.withTasks))

      // Only add withQuizzes if withTasks is true
      if (this.withTasks) {
        params.append('withQuizzes', String(this.withQuizzes))
      }
    }

    return `?${params.toString()}`
  }
}
